import { gql, useLazyQuery } from "@apollo/client"
import { useQuery, UseQueryOptions } from "@oysterhr/core"
import { CollectionMetadata, EmployerOfRecord, QueryEmployersOfRecordArgs } from "@oysterhr/schema"

export const VENDOR_EMPLOYERS_OF_RECORD_COLLECTION_QUERY = gql`
  query VendorEmployersOfRecordCollection(
    $countryCode: String
    $entityType: String
    $query: String
  ) {
    employersOfRecord(countryCode: $countryCode, entityType: $entityType, query: $query) {
      collection {
        id
        name
        employerOfRecordCountry {
          alpha2
        }
      }
      metadata {
        totalCount
      }
    }
  }
`

export type QueryArgs = Pick<QueryEmployersOfRecordArgs, "countryCode" | "entityType" | "query">
export type QueryResponse = {
  employersOfRecord: {
    collection: Pick<EmployerOfRecord, "id" | "name" | "employerOfRecordCountry">[]
    metadata: Pick<CollectionMetadata, "totalCount">
  }
}

export const useEmployersOfRecord = (options?: UseQueryOptions<QueryResponse, QueryArgs>) =>
  useQuery<QueryResponse, QueryArgs>(VENDOR_EMPLOYERS_OF_RECORD_COLLECTION_QUERY, options)

export const useLazyEmployersOfRecord = (options?: UseQueryOptions<QueryResponse, QueryArgs>) =>
  useLazyQuery<QueryResponse, QueryArgs>(VENDOR_EMPLOYERS_OF_RECORD_COLLECTION_QUERY, {
    ...options,
    fetchPolicy: "no-cache",
  })
